import React from 'react';
import './init';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import { TranslatorProvider } from '@front-activerse/common-components';
import translationsEnUS from './locales/en-US/translations.json';
import translationsSvSE from './locales/sv-SE/translations.json';
import { AuthLoginByTokenContainer } from '@front-activerse/common-components';
import { Apollo } from '@front-activerse/common-components';

const translations = [
  { lang: 'en-US', translation: translationsEnUS },
  { lang: 'sv-SE', translation: translationsSvSE },
];

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Apollo>
      <TranslatorProvider fallbackLanguage="en-US" translations={translations}>
        <AuthLoginByTokenContainer>
          <App />
        </AuthLoginByTokenContainer>
      </TranslatorProvider>
    </Apollo>
  </StrictMode>
);
